import { Link } from 'react-router-dom';
import { Nav,Bot,Section,Photo,Icon,Space,Text,AnimatedText } from '../Symbols.js'
import { ProgramLaunch } from '../Banners'

export default (props)=>{
    return <>
        <Nav light className="float" />
        <Section className="page flex" style={{color:"white",justifyContent:"flex-end"}}>
            <div className="group flex top" style={{zIndex:"1"}}>
                <Space h="128"/>
                <Text className="ready standby fade-in">About us</Text>
                <Text size="XXXL" className="slim accentFont" style={{textShadow:"4px 8px 32px #224"}}>
                    <AnimatedText
                        className="ready zoom bounce"
                        text="We believe everyone deserves the power of communication"
                        size = "XXXL"
                        class = "accentFont"
                    />
                </Text>
            </div>
            <Photo src="about0.png" style={{
                position:"absolute",
                top:"0",left:"0",
                width:"100%",height:"100%",
                zIndex:"0",
                borderRadius:"0"
            }} thumbnail="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"/>
        </Section>
        <Section className="center" wrapperClass="narrow">
            <div className="group">
                <Text className="blue standby subtle-in delay3">Our Mission</Text>
                <Space h="16"/>
                <div>
                    <AnimatedText
                        className="simple"
                        text="Meaningful help through easy access and understanding."
                        size = "XXL"
                    />
                </div>
                <Space h="16"/>
                <Text className="standby fade-in delay2 dusk">
                    We are a group of solution-minded people who aim to provide the community with the only software capable of connecting you and an interpreter, with ease.
                </Text>
            </div>
        </Section>
        <div className="transition"/>
        <Section>
            <div className="grid split2x512 desktopFlip">
                <Photo src="about1.jpg" className="standby fade-in" style={{minHeight:"512px"}}/>
                <div className="standby fade-in delay2 group flex top">
                    <Icon w="64" h="64" src="article-blue.svg"/>
                    <Space h="16"/>
                    <Text size="XXL">
                        How we plan to solve inequality in the deaf community.
                    </Text>
                    <Text className="dusk">
                        Learn about the stories that drive us to innovate.
                    </Text>
                    <Space h="16"/>
                    <div>
                        <Link to="/about/plan/" className="button blue">
                            <Text>Read article</Text>
                        </Link>
                    </div>
                </div>
            </div>
            <Space h="96"/>
            <div className="grid split2x512">
                <Photo src="about2.jpg" className="standby fade-in" style={{minHeight:"512px"}}/>
                <div className="standby fade-in delay2 group flex top">
                    <Icon w="64" h="64" src="verify-blue.svg"/>
                    <Space h="16"/>
                    <Text size="XXL">
                        Our commitment to your safety and trust.
                    </Text>
                    <Text className="dusk">
                        We're committed to making a difference to ensure a secure environment for our clients.
                    </Text>
                    <Space h="16"/>
                    <div>
                        <Link to="/safety/" className="button blue">
                            <Text>Our safety procedures</Text>
                        </Link>
                    </div>
                </div>
            </div>
        </Section>
        <Section className="center blue">
            <Icon className="standby fade-in" w="128" h="128" src="beta-logo-app.svg" style={{borderRadius:"23%",boxShadow:"0 24px 48px -8px #2D2FC3"}} />
            <Space h="48"/>
            <div style={{maxWidth:"640px"}}>
                <AnimatedText
                    className="center"
                    text="You need Interpreters. We've got you covered."
                    size = "XXL"
                    class="center"
                />
            </div>
            <Space h="32"/>
            <Link to="/book/" className="standby fade-in delay1 button white">
                <Text>Search now</Text>
            </Link>
        </Section>
        <Section className="black" style={{backgroundImage:"url(/static/photos/jacob.png)"}}>
            <div className="standby fade-in group flex top">
                <Space h="128"/>
                <Icon w="64" h="64" src="article-white.svg"/>
                <Space h="16"/>
                <Text>Meet the Founder</Text>
                <Text size="XXL">A letter<br/>from Jacob</Text>
                <Space h="16"/>
                <Link to="/about/letter/" className="standby fade-in button white">
                    <Text>Read Jacob's letter</Text>
                </Link>
                <Space h="64"/>
            </div>
        </Section>
        <Section className="center">
            <Text size="XXL" className="standby fade-in">Explore our services</Text>
            <Space h="16"/>
            <Text className="slim standby fade-in dusk">We connect interpreters and clients the modern way–with an easy to use app that works for you. Find what you need cheaper, and in just seconds.</Text>
            <Space h="64"/>
            <div className="grid split3x512">
                <Link to="/deaf/" className="standby fade-in flex card blue">
                    <Space h="8"/>
                    <Icon w="48" h="48" src="deaf-white.svg"/>
                    <Space h="16"/>
                    <div><Text>for</Text></div>
                    <Text size="XL">Deaf</Text>
                </Link>
                <Link to="/interpreters/" className="standby fade-in delay1 flex card blue">
                    <Space h="8"/>
                    <Icon w="48" h="48" src="interpreters-white.svg"/>
                    <Space h="16"/>
                    <div><Text>for</Text></div>
                    <Text size="XL">Interpreters</Text>
                </Link>
                <Link to="/organizations/" className="standby fade-in delay2 flex card blue">
                    <Space h="8"/>
                    <Icon w="48" h="48" src="organizations-white.svg"/>
                    <Space h="16"/>
                    <div><Text>for</Text></div>
                    <Text size="XL">Organizations</Text>
                </Link>
            </div>
        </Section>
        <ProgramLaunch/>
        <Bot/>
    </>
}